export default __webpack_public_path__ + "static/slider-bus-mb-bea60688ab14268eef867732bee31883.png";